import { useSyncExternalStore } from "react";
/**
 * useViewModel binds a (framework-agnostic) ViewModel to React. The View
 * re-renders whenever the VM's state changes. This is the only place the View
 * layer touches the VM internals.
 */
export function useViewModel(vm) {
    return useSyncExternalStore((onChange) => vm.subscribe(onChange), () => vm.state, () => vm.state);
}
//# sourceMappingURL=useViewModel.js.map